import { Box, Skeleton, Grid, GridItem } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Wrapper } from '../../../components/Wrapper';
import PengetahuanDetailContext, {
  usePengetahuanDetailContext,
} from '../../../controller/pengetahuan/detail';

import PengetahuanQuizContext from '../../../controller/pengetahuan/quiz';
import PengetahuanAssesmentContext from '../../../controller/pengetahuan/assesment';
import DiskusiContext from '../../../controller/pengetahuan/diskusi';
import ModalConfirmationRegisterSpeaker from '../../../components/Pengetahuan/ModalConfirmationRegister';
import ModalConfirmationPengetahuan from '../../../components/Pengetahuan/ModalConfirmationPengetahuan';
import ModalSuccessKlinikKhusus from '../../../components/Pengetahuan/ModalSuccessKlinikKhusus';

import PengetahuanInfo from './PengetahuanInfo';
import PengetahuanMateri from './PengetahuanMateri';
import PengetahuanSelesaiSection from './PengetahuanSelesaiSection';
import PengetahuanHeader from './PengetahuanHeader';

/**
 * Component for displaying detailed knowledge content.
 * @returns {JSX.Element} The DetailPengetahuan component.
 * @author Bagas Prasetyadi
 */

const DetailPengetahuan = () => {
  const {
    fetchData,
    setPengetahuanDetailState,
    postVideoCompleted,
  } = usePengetahuanDetailContext();
  const { pengetahuanItem, loadingData } =
    usePengetahuanDetailContext().state;

  const playerRef = React.useRef(null);
  const location = useLocation();

  const pengetahuanId = window.location.pathname.split('/', 4)[3];

  // Get query parameter
  const searchParams = new URLSearchParams(location.search);
  const viewParam = searchParams.get('view');

  useEffect(() => {
    fetchData(pengetahuanId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pengetahuanId]);

  const getYouTubeVideoId = (url) => {
    const urlObj = new URL(url);
    const videoId = urlObj.searchParams.get('v');
    return videoId;
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    player.on('ended', () => {
      postVideoCompleted(
        pengetahuanItem?.pengetahuan_materi_saya?.t_pengetahuan_id
      );
    });
  };

  const handleOpenModal = () => {
    setPengetahuanDetailState('isOpenModalConfirmationPengetahuan', true);
    if (
      pengetahuanItem?.jenis_pengetahuan === 'synchronized' &&
      pengetahuanItem?.status_pengetahuan === null
    ) {
      setPengetahuanDetailState('statusPost', 'menunggu');
    } else {
      setPengetahuanDetailState('statusPost', 'mengikuti');
    }
  };

  const isYoutubeStream =
    pengetahuanItem?.pengetahuan_materi_saya?.link_streaming?.includes(
      'youtube'
    );

  const youtubeId =
    isYoutubeStream &&
    getYouTubeVideoId(pengetahuanItem?.pengetahuan_materi_saya?.link_streaming);

  // Determine which view to render based on status
  const renderContent = () => {
    if (loadingData) {
      return (
        <Grid templateColumns="repeat(8, 1fr)" gap={{ base: 3, md: 5 }}>
          <GridItem colSpan={{ base: 8, md: 3 }}>
            <Skeleton h="200px" w="full" mb={4} />
          </GridItem>
          <GridItem colSpan={{ base: 8, md: 5 }}>
            <Skeleton h="200px" w="full" mb={4} />
          </GridItem>
        </Grid>
      );
    }

    // Status: mengikuti (sedang diikuti)
    if (pengetahuanItem?.status_pengetahuan === 'mengikuti') {
      return (
        <PengetahuanMateri
          pengetahuanItem={pengetahuanItem}
          handlePlayerReady={handlePlayerReady}
          youtubeId={youtubeId || ''}
        />
      );
    }

    // Status: selesai (both synchronized and asynchronized)
    if (pengetahuanItem?.status_pengetahuan === 'selesai') {
      // show materi
      if (viewParam === 'materi') {
        return (
          <PengetahuanMateri
            pengetahuanItem={pengetahuanItem}
            handlePlayerReady={handlePlayerReady}
            youtubeId={youtubeId || ''}
          />
        );
      }

      return (
        <>
          <PengetahuanHeader pengetahuanItem={pengetahuanItem} />
          <PengetahuanSelesaiSection pengetahuanItem={pengetahuanItem} />
        </>
      );
    }

    // Status: null
    return (
      <PengetahuanInfo
        pengetahuanItem={pengetahuanItem}
        handleOpenModal={handleOpenModal}
      />
    );
  };

  return (
    <>
      <Box m={{ base: 2, md: 8 }}>
        {renderContent()}
        <ModalConfirmationRegisterSpeaker />
        <ModalConfirmationPengetahuan pengetahuanId={pengetahuanId} />
        <ModalSuccessKlinikKhusus />
      </Box>
    </>
  );
};

const WrapperMain = () => {
  return (
    <Wrapper>
      <DetailPengetahuan />
    </Wrapper>
  );
};

const DetailPengetahuanMain = () => {
  return (
    <PengetahuanDetailContext.Provider>
      <PengetahuanQuizContext.Provider>
        <PengetahuanAssesmentContext.Provider>
          <DiskusiContext.Provider>
            <WrapperMain />
          </DiskusiContext.Provider>
        </PengetahuanAssesmentContext.Provider>
      </PengetahuanQuizContext.Provider>
    </PengetahuanDetailContext.Provider>
  );
};

export default DetailPengetahuanMain;
